import { render, staticRenderFns } from "./BaseFormATCommand.vue?vue&type=template&id=5983ca8a&scoped=true&"
import script from "./BaseFormATCommand.vue?vue&type=script&lang=js&"
export * from "./BaseFormATCommand.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormATCommand.vue?vue&type=style&index=0&id=5983ca8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983ca8a",
  null
  
)

export default component.exports